import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './Home.css';

import { Link } from 'react-router-dom';
import { withFirebase } from '../firebase';
import { withAuthorization, AuthUserContext } from '../session';
import {iso_from_ts} from '../utils.js'
import Loader from '../components/Loader.js';
import toastr from 'toastr';
import {clone} from 'lodash'
import Modal from 'react-modal';

import * as ROUTES from '../constants/routes';

const MODAL_STYLE = {
  content : {
    top                   : '40%',
    bottom                : 'auto',
    width: '400px',
    marginLeft: 'auto',
    marginRight: 'auto'
  }
};

const Home = () => {
  return (
    <AuthUserContext.Consumer>
        {(ctx) => (
          <div>
            <img
              className="Create-logo"
              src={process.env.PUBLIC_URL + '/img/logo.png'}
              alt="logo"
            />
            <h1 className="Create-title">SONA Menu <a href="http://sonad.io/instruction.html#anchor-u41626" target="_blank" rel="noopener noreferrer" className="Help">?</a></h1>
            <SonaList admin={ctx.admin} />
          </div>
        ) }
    </AuthUserContext.Consumer>
  )
}

const INITIAL_STATE = {
  loading: true,
  query: '',
  sonas: [],
  sort: 'name',
  confirm_delete_sona_id: null
};

class SonaListBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };

    this.SORT_OPTS = [
      { value: 'name', label: "Name" },
      { value: 'uid', label: "ID" },
      { value: 'createDate', label: "Date Created" }
    ]

    this.sortChange = this.sortChange.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.deleteSONA = this.deleteSONA.bind(this)
    this.copySONA = this.copySONA.bind(this)
  }

  componentDidMount() {
    this.fetchSONAs()
  }

  componentWillUnmount() {
    this.props.firebase.sonas().off();
  }

  onSearchTermChange = event => {
    this.setState({ query: event.target.value });
  };

  sortChange(event) {
    this.setState({sort: event.target.value})
  }

  closeModal() {
    this.setState({confirm_delete_sona: null});
  }

  filteredSONAs() {
    let {sonas, query, sort} = this.state;
    let filtered_sorted_list = sonas
    if (query.length > 0) {
      filtered_sorted_list = sonas.filter(sona => {
        let svs = []
        let keys = ['name', 'uid', 'body']
        keys.forEach((key) => {
          if (sona[key] != null) svs.push(sona[key].toLowerCase())
        })
        let search_value = svs.join(' ')
        return search_value.indexOf(query.toLowerCase()) !== -1;
      })
    }
    if (sort === 'name' || sort === 'uid') filtered_sorted_list.sort((s1, s2) => {
      let val1 = s1[sort] ? s1[sort].toUpperCase() : ''
      let val2 = s2[sort] ? s2[sort].toUpperCase() : ''
      if (val2 < val1) return 1
      else if (val2 > val1) return -1
      else return 0
    })
    if (sort === 'createDate') filtered_sorted_list.sort((s1, s2) => {
      let val1 = s1.createDate || 0
      let val2 = s2.createDate || 0
      if (val2 < val1) return -1
      else if (val2 > val1) return 1
      else return 0
    })
    return filtered_sorted_list
  }

  confirmDeleteSONA(sona) {
    this.setState({confirm_delete_sona: sona})
  }

  copySONA(sona) {
    // Pass sona text data (not multimedia) to edit form via serialized JSON
    let copy = clone(sona)
    const URL_FIELDS = [
      'facebook', 'twitter', 'instagram', 'youtube',
      'google', 'pinterest', 'snapchat',
      'website', 'website2', 'website3', 'phoneNum', 'textScreen3', 'inPhoneNum', 'option1', 'option2', 'option3', 'option4', 'option5']
    const CLEAR_FIELDS = ['Audio_barcode', 'ABOUT_ME', 'extraImage', 'extraImage2', 'extraImage3', 'code', 'logo', 'sona_id_ok', 'downloadable_media']
    CLEAR_FIELDS.forEach((key) => {
      delete copy[key]
    })
    URL_FIELDS.forEach((key) => {
      if (copy.urls[key] != null) copy[key] = copy.urls[key]
    })
    delete copy.urls
    copy.createDate = new Date().getTime()
    copy.uid = copy.uid + '_' + copy.createDate  // Append timestamp to copy
    let serialized_sona = JSON.stringify(copy)
    this.props.history.push(`/create?populate=${encodeURIComponent(serialized_sona)}`);
  }

  deleteSONA() {
    const AUTH = '5LgdMbRQacz5XMrhFCxR' // TODO
    let data = new FormData();
    let sona = this.state.confirm_delete_sona
    data.append('auth', AUTH);
    data.append('code', sona.code);
    let url = 'https://firebase-sonad.appspot.com/api/delete';
    fetch(url, {
        method: 'POST',
        body: data
    }).then(response => response.json()).then(res => {
      this.props.firebase.sona(sona.uid).remove().then((res) => {
        this.closeModal()
        toastr.success("SONA deleted");
      })
    }).catch(
      error => console.log(error) // Handle the error response object
    );
  }

  fetchSONAs() {
    let {admin} = this.props
    let user = this.props.firebase.auth.currentUser
    let query = this.props.firebase.sonas()
    if (!admin) query = query.orderByChild('userId').equalTo(user.uid)
    query
      .on('value', snapshot => {
        const sonasObject = snapshot.val();
        if (sonasObject && Object.keys(sonasObject).length > 0) {
          let sonasList = Object.keys(sonasObject).map(key => ({
            ...sonasObject[key],
            uid: key,
          }))
          this.setState({
            sonas: sonasList,
            loading: false
          });
        } else {
          this.setState({
            sonas: [],
            loading: false
          });
        }
      });
  }

  render() {
    let { query, sonas, loading, sort, confirm_delete_sona } = this.state;
    let {admin} = this.props
    let empty = !loading && sonas.length === 0
    let filtered = this.filteredSONAs()
    let modalIsOpen = confirm_delete_sona != null
    let confirm_delete_sona_id = ''
    if (modalIsOpen) confirm_delete_sona_id = confirm_delete_sona.uid
    let search_empty = !loading && query.length > 0 && filtered.length === 0
    return (
      <div>
        <div hidden={!admin}>
          <label>Sort by:</label>&nbsp;
          <select className="sort" name="sort" value={sort} onChange={this.sortChange}>
            { this.SORT_OPTS.map((so) => {
              return <option key={so.value} value={so.value}>{so.label}</option>
            })}
          </select><br/>
        </div>
        <input
          className="Home-input"
          name="query"
          value={query}
          onChange={this.onSearchTermChange}
          type="text"
          placeholder="Search"
        />

        <ul className="Home-list">
          {filtered.map((sona, i) => (
            <li key={`code-${sona.uid}`}>
              <div className="sonaLI">
                <Link className="sonaLink" to={`/edit/${sona.uid}`}>{sona.name}</Link>
                <a href="javascript:void(0)" className="actionIcon sonaDelete" title="Delete" onClick={this.confirmDeleteSONA.bind(this, sona)}><i className="fa fa-trash"></i></a>
                <a href="javascript:void(0)" className="actionIcon sonaCopy" title="Create Copy" onClick={this.copySONA.bind(this, sona)}><i className="fa fa-copy"></i></a>
                <Link to={`/analyze/${sona.uid}`}><i className="fa fa-chart-area"></i></Link>
                <div className="secondary">{sona.uid} &middot; { iso_from_ts(sona.createDate) }</div>
              </div>
            </li>
          ))}
        </ul>

        { loading ? <p><Loader /> Loading...</p> : null }
        { empty ? <p>No SONAs created. <Link to={ROUTES.CREATE}>Create your first</Link>.</p> : null }
        { search_empty ? <p>No SONAs matching query</p> : null }

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Confirm delete"
          ariaHideApp={false}
          style={MODAL_STYLE}
        >

          <p style={{fontSize: 17}}>Be aware that SONA <b>{confirm_delete_sona_id}</b> will be removed from the database along with the associated audio code. This action cannot be undone.</p>
          <button className="BigButton" onClick={this.deleteSONA}>Yes, delete</button>
          <button className="BigButton White" onClick={this.closeModal}>No, cancel</button>

        </Modal>

      </div>
    );
  }
}

const SonaList = withRouter(withFirebase(SonaListBase));

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Home);

export { SonaList };
